
import React, { useState, useEffect, useRef, useContext } from 'react'
import {
    Container,
    Card,
    Typography,
    AppBar,
    Toolbar,
    Box,
    Tab,
    Tabs,
    Chip,
    Stack,
    Grid,
    CardMedia,
    Divider,
    SwipeableDrawer,
    Paper,
    List,
    ListItem,
    Checkbox,
    Button,
    Input,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Alert
} from '@mui/material';
import { ArrowBackIos, HolidayVillage, FileDownload, OpenInNew, Upload, Close } from '@mui/icons-material';
import logoQrcode from '../../assets/images/logo/qr-code-logo.png'
import logoDebitCard from '../../assets/images/logo/debit-card.png'
import logoMobileBank from '../../assets/images/logo/mobile-banking.png'
import logo2c2p from '../../assets/images/logo/2C2P_Logo.png'
import logoNoImage from '../../assets/images/no-image.jpg'
import logoCheck from '../../assets/images/logo/check.png'
import { ProfileContext } from '../../contexts/ProfileContext';
import { DisclaimerContext } from '../../contexts/DisclaimerContext';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import { BackDropLoading } from '../../ui-component'
import { ChipRoomInfo } from '../../ui-component/ChipRoomInfo';
import * as api from '../../api/BillPayment'
import * as apiMain from '../../api'
import * as dict from '../../dictionary'
import { useTheme } from '@mui/material'
import { checkProductType } from "../../utils/checkProductType";
import axios from 'axios';
import CustomWatermarkCard from './components/CardWithWaterMark';
import { checkPaymentType } from '../../utils/checkPaymentType';
export const BillPayment = ({ version='1' }) => {
    const [tabSelected, setTabSelected] = useState("waiting")
    const [isVisibleMenuMethod, setIsVisibleMenuMethod] = useState(false)
    const [methodType, setMethodType] = useState(null)
    const [houseInfo, setHouseInfo] = useState(null)
    const [billPaymentPM, setBillPaymentPM] = useState([])
    const [billPaymentREM, setBillPaymentREM] = useState([])
    const [billPaymentRental, setBillPaymentRental] = useState([])
    const [summaryBillPaymentRental, setSummaryBillPaymentRental] = useState({})
    const [totalBalance, setTotalBalance] = useState(0)
    const [loadingBackDrop, setLoadingBackDrop] = useState(false)
    const [lineId, setLineId] = useState(null)
    const [profile, setProfile] = useState(null)
    const [detail, setDetail] = useState(null)
    let houseInfoSelected = localStorage.getItem("houseInfoSelected")
    let contractSelected = localStorage.getItem("contractSelected")
    const [houseInfoParse] = useState(JSON.parse(houseInfoSelected))
    const [contractSelectedParse] = useState(JSON.parse(contractSelected))
    const [noMerchantId, setNoMerchantId] = useState(false)
    const [callCenter, setCallCenter] = useState("")
    const [projectDetail, setProjectDetail] = useState(null)
    const [isDataReady, setIsDataReady] = useState(false)
    const [hasAnyData, setHasAnyData] = useState(false)
    // Version 2
    const [checkTerms, setCheckTerms] = useState([])
    const [checkInvoiceTermsDict, setCheckInvoiceTermsDict] = useState({})
    const [selectedFile, setSelectedFile] = useState(null)
    const [showImageDialog, setShowImageDialog] = useState(false)
    const [uploadSlipError, setUploadSlipError] = useState(false)
    const [showSuccessMessage, setShowSuccessMessage] = useState(false)
    const [fileSizeError, setFileSizeError] = useState(false)

    const myRef = useRef(null)
    const fileInputRef = useRef(null)
    const context = useContext(ProfileContext)

    const location = useLocation()
    const navigate = useNavigate()
    const theme = useTheme()
    const params = new URLSearchParams(location.search);
    const disableCreditCardMethod = params.get("disableCreditCardMethod");
    const showUploadSlip = params.get("uploadSlip");
    let isKbank = localStorage.getItem("kbank")
    let isScb = localStorage.getItem("scb")
    let is2c2p = localStorage.getItem("2c2p")
    let disable2c2pMethod = params.get("disable2c2p_method");
    const payOrPaid = (element) => {
        if (element.pay_amount) {
            return element.pay_amount?.toLocaleString()
        }
        return element.paid_amount?.toLocaleString()
    }

    const checkDisabledCreditMethod = (term_id) => {

        if(disableCreditCardMethod === "true") return true
        // let term = parseInt(term_id)
        // if (term === 998) {
        //     return true
        // }
        // if (term >= 200 && term <= 299) {
        //     return true
        // } comment เอาออกไปก่อนอาจมีโอกาศเอากลับมาใช้ ตรงนี้ใช้เพื่อดักกรณีที่เป็นเงินงวดดาวน์จะไม่ให้ชำระผ่านบัตรเครดิต
        return false
    }

    const checkDisabled = (element, index, temp) => {

        if (element.product_type === "rental") {
            if (projectDetail?.ProjectID === element.project_id && projectDetail?.EnablePaymentLineOA === 0) {
                return true
            }
            return false
        }

        if (index === 0 || (element.invoice_due_date === temp[0].invoice_due_date)) {
            return false
        }
        return true
    }

    const checkShowWaterMark = (element) => {
        if (element.product_type === "rental") {
            if (projectDetail?.ProjectID === element.project_id && projectDetail?.EnablePaymentLineOA === 0) {
                return true
            }
            return false
        }
        return false
    }

    const backgroundDisabled = (element, index, temp) => {
        if (tabSelected !== "waiting") return

        if (version === "2" && element?.data?.length > 0) {
            const someDisabled = element.data.some(item => item.disbale === false)
            if (someDisabled) {
                return ""
            }
            return "#E0E0E0"
        }

        if (element.product_type === "rental") {
            if (projectDetail?.ProjectID === element.project_id && projectDetail?.EnablePaymentLineOA === 0) {
                return "#E0E0E0"
            }
            return ""
        }

        if (index === 0 || (element.invoice_due_date === temp[0].invoice_due_date)) {
            return ""
        }
        return "#E0E0E0"
    }

    // Version 2
    const checkBoxTermDisabled = (element, index, temp) => {
        const checkTermOfInvoice = checkTerms.find(item => item.invoice_no === element.invoice_no)
    }

    const onChangeBillPaymentForDisbaleCheckbox = (initTermChecked) => {
        let billpaymentV2 = []
        if (checkProductType() === "rental") {
            billpaymentV2 = billPaymentRental
        }
        if (billpaymentV2.length === 0){
            return
        }
        let enableTerms = []
        const newInviceTerms = billpaymentV2.map((invioce) => {
            let disbaleAll = false
            const newTerms = invioce.data.map((term) => {
                let disbale = false
                const isCheck = initTermChecked.findIndex(item => item.term_id === term.term_id)
                if (isCheck !== -1) {
                    const isTermEnableExist = enableTerms.findIndex(item => item === term.term_id)
                    if (isTermEnableExist === -1) {
                        enableTerms.push(term.term_id)
                    }
                    initTermChecked = [...initTermChecked.slice(0, isCheck), ...initTermChecked.slice(isCheck + 1)]
                }
                else if (isCheck === -1 && invioce.is_term_step_exist){
                    const isEnable = enableTerms.findIndex(item => item === term.term_id)
                    if(isEnable !== -1){
                        disbale = false
                        enableTerms = [...enableTerms.slice(0, isEnable), ...enableTerms.slice(isEnable + 1)]
                    }
                    else{
                        disbale = true
                        if (!disbaleAll){
                            disbaleAll = true
                        }
                    }
                }
                const newTerm = {
                    ...term,
                    disbale: disbale
                }
                return newTerm
            })
            const newInvoice = {
                ...invioce,
                disbale: disbaleAll,
                data: newTerms
            }
            return newInvoice
        })

        if (checkProductType() === "rental") {
            setBillPaymentRental(newInviceTerms)
        }
    }

    const handleCheckTerms = (elements=[]) => {
        let temps = checkTerms
        let newTemp = []

        for (const element of elements) {
            const tempIndex = temps.findIndex(item => (item.term_id === element.term_id && item.invoice_no === element.invoice_no))
            if (tempIndex !== -1) {
                const sameTermStepList = temps.slice(tempIndex + 1).filter(item => item.term_id === element.term_id)
                newTemp = [...temps.slice(0, tempIndex), ...temps.slice(tempIndex + 1)]
                    .filter((item, index) => {
                        if (index >= tempIndex) {
                            const foundIndex = sameTermStepList.findIndex(sameTerm => sameTerm.term_id === item.term_id)
                            const isSameStep = foundIndex !== -1
                            return !isSameStep
                        }
                        return true
                    })
            } else {
                newTemp = [...temps, element]
            }
            temps = newTemp
        }
        const newTermOfInvoice = newTemp.reduce((acc, item) => {
            if (acc[item.invoice_no]) {
                acc[item.invoice_no].push(item)
            } else {
                acc[item.invoice_no] = [item]
            }
            return acc
        }, {})
        const newTotalBalance = newTemp.reduce((acc, item) => {
            acc += item.balance
            return acc
        }, 0)
        setTotalBalance(newTotalBalance)
        setCheckTerms(newTemp)
        setCheckInvoiceTermsDict(newTermOfInvoice)
        onChangeBillPaymentForDisbaleCheckbox([...newTemp])
    }

    const handleCheckInvoice = (element) => {
    if (element.data.length === 0) {
        return
    }
    
    const isCurrentlyChecked = isInvoiceChecked(element)
    const isIndeterminate = isInvoiceIndeterminate(element)
    
    if (isCurrentlyChecked) {
        const termsToUncheck = element.data.filter(term => isTermChecked(term))
        handleCheckTerms(termsToUncheck) 
    } else if (isIndeterminate) {
        const termsToCheck = element.data.filter(term => !isTermChecked(term))
        handleCheckTerms(termsToCheck)
    } else {
        const payableTerms = element.data?.filter(term => term.invoice_payable !== undefined ? Boolean(term.invoice_payable) : true) || []
        handleCheckTerms(payableTerms)
    }
}

    const isTermChecked = (element) => {
        let temp = checkTerms
        let index = temp.findIndex(item => (item.term_id === element.term_id 
            && item.invoice_no === element.invoice_no
            && (item.invoice_payable !== undefined ? Boolean(item.invoice_payable) : true) 
        ))
        if (index !== -1) {
            return true
        }
        return false
    }

    const isInvoiceChecked = (element) => {
    const invoiceDict = checkInvoiceTermsDict[element.invoice_no]
    if (!invoiceDict || element.data.length === 0) {
        return false
    }
    
    const allTermsSelected = element.data.every(term => 
        invoiceDict.some(checkedTerm => 
            checkedTerm.term_id === term.term_id && 
            checkedTerm.invoice_no === term.invoice_no
        )
    )
    
    return allTermsSelected
}

    const isInvoiceIndeterminate = (element) => {
    const invoiceDict = checkInvoiceTermsDict[element.invoice_no]
    if (!invoiceDict || element.data.length === 0) {
        return false
    }
    
    const selectedCount = element.data.filter(term => 
        invoiceDict.some(checkedTerm => 
            checkedTerm.term_id === term.term_id && 
            checkedTerm.invoice_no === term.invoice_no
        )
    ).length
    
    return selectedCount > 0 && selectedCount < element.data.length
}

const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
        // Check file size (1MB = 1024 * 1024 bytes)
        const maxSizeInBytes = 1024 * 1024; // 1MB
        
        if (file.size > maxSizeInBytes) {
            setFileSizeError(true);
            // Reset file input to allow selecting the same file again
            event.target.value = '';
            return;
        }
        
        setFileSizeError(false);
        
        // Convert file to blob while preserving the filename
        const blob = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
                // Convert the file to a blob with the original filename
                fetch(reader.result)
                    .then(res => res.blob())
                    .then(blob => {
                        // Create a new blob with the original file type
                        const fileBlob = new Blob([blob], { type: file.type });
                        // Add the name property to the blob to preserve the filename
                        fileBlob.name = file.name;
                        resolve(fileBlob);
                    });
            };
            reader.readAsDataURL(file);
        });
        console.log('blob', blob)
        setSelectedFile(blob);
        setShowImageDialog(true);
    }
}

const handleCloseImageDialog = () => {
    setShowImageDialog(false);
    setFileSizeError(false);
}

const statusShows = (date) => {
        let expiration = moment(date).format("YYYY-MM-DD");
        let current_date = moment().format("YYYY-MM-DD");
        let days = moment(expiration).diff(current_date, 'days');

        if (days < 0) return <Typography variant='caption' fontWeight={"bold"} sx={{ color: "#EB5757" }}> {dict.Over_Payment_Due_TXT[profile?.language]} </Typography>
        return <Typography variant='caption' fontWeight={"bold"} sx={{ color: "#F2994A" }}> {dict.Wait_Payment_TXT[profile?.language]} </Typography>
    }

    const receiptStatusShows = (label) => {
        if (label === "รอยืนยันเงิน" || label === "Waiting Confirm") {
            return <Typography variant='caption' fontWeight={"bold"} sx={{ color: "#FFA500" }} >{label}</Typography>
        }
        return <Typography variant='caption' fontWeight={"bold"} sx={{ color: "#81B622" }} >{label}</Typography>
    }

    const InsideCard = ({ element }) => {
        return <Box sx={{ width: "100%", p: 3 }}>

            {
                (checkProductType() === "rental" && element?.invoice_no) && <Stack mb={1}>
                    <Typography variant='body2' fontWeight={"bold"}>{element?.invoice_no}</Typography>
                </Stack>
            }

            <Stack direction="row" justifyContent="space-between">
                <Typography variant="body2" sx={{ flexShrink: 0 }}>
                    {dict.Bill_Type_TXT[profile?.language]}

                </Typography>
                <Typography variant="body2" fontWeight={"bold"} sx={{ wordBreak: "break-word" }}>
                    {profile?.language === "th" ? element.term_name : element.term_name_eng || "-"}

                </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" mt={1}>
                <Typography variant="body2" >
                    {dict.Pay_Due_TXT[profile?.language]}

                </Typography>
                <Typography variant="body2" fontWeight={"bold"}>
                     {/* {tabSelected === "waiting" ? moment(element.invoice_due_date).format("DD/MM/YYYY") : moment(element.payment_date).format("DD/MM/YYYY")} */}
                    {moment(element.invoice_due_date).format("DD/MM/YYYY")}
                 </Typography>
            </Stack>
            {
                tabSelected === "history" && <Stack direction="row" justifyContent="space-between" mt={1}>
                    <Typography variant="body2" >
                        {dict.Pay_Date_TXT[profile?.language]}

                    </Typography>
                    <Typography variant="body2" fontWeight={"bold"}>
                        {/* {tabSelected === "waiting" ? moment(element.invoice_due_date).format("DD/MM/YYYY") : moment(element.payment_date).format("DD/MM/YYYY")} */}
                        {moment(element.payment_date).format("DD/MM/YYYY")}
                    </Typography>
                </Stack>
            }
            <Stack direction="row" justifyContent="space-between" mt={1}>
                <Typography variant="body2" sx={{ flexShrink: 0 }} >
                    {dict.Bill_Amount_TXT[profile?.language]}

                </Typography>
                <Typography variant="body2" fontWeight={"bold"} sx={{ wordBreak: "break-word" }}>
                    {tabSelected === "waiting" ? (element.balance?.toLocaleString()) : payOrPaid(element)} {dict.Baht_TXT[profile?.language]}
                </Typography>
            </Stack>
            {
                tabSelected === "history" && <Stack direction="row" justifyContent="space-between" mt={1}>
                    <Typography variant="body2" >
                        {dict.Pay_Via_TXT[profile?.language]}

                    </Typography>
                    <Typography variant="body2" fontWeight={"bold"} >
                        {element.receipt_payment_type_text || "-"}
                    </Typography>
                </Stack>
            }
            <Stack direction="row" justifyContent="space-between" mt={1}>
                <Typography variant="body2" >
                    {dict.Bill_Status_TXT[profile?.language]}
                </Typography>
                <Typography variant="caption" >
                    {tabSelected === "waiting" ? <Chip label={statusShows(element.invoice_due_date)} /> : <Chip label={receiptStatusShows(element.status_upload)} />}
                </Typography>
            </Stack>
            {
                (element.term_id === "100" && tabSelected !== "history" && element?.contract_down_period !== "" && element?.contract_down_period !== undefined) && <Stack direction="column" mt={1}>
                    <Typography variant="body2" fontWeight={"bold"} color={"red"} >
                        {dict.Remark_TXT[profile?.language]} :
                    </Typography>
                    <Typography variant="body2" >
                       {dict.Split_Payment_TXT[profile?.language]}
                    </Typography>
                    <Typography variant="body2">
                        {dict.Split_Payment_2_TXT[profile?.language] + " " + element.contract_down_period + " " + dict.Split_Payment_3_TXT[profile?.language]}
                    </Typography>
                    <Typography variant="body2">
                    {dict.Split_Payment_4_TXT[profile?.language] + " " + (Number(element.contract_down_per_payment)).toLocaleString() + " " + dict.Split_Payment_5_TXT[profile?.language]}
                    </Typography>
                </Stack>
            }

            {
                (tabSelected === "history" && (element.status_upload === "ชำระเงินสำเร็จ" || element.status_upload === "Payment Confirmed")) && <>
                    <Divider sx={{ ml: -10, mr: -10, mt: 2 }} />
                    <Stack direction={"row"} justifyContent={"center"} mt={1}>
                        <Typography variant='body1' fontWeight={"bold"} color={theme.palette.primary.main}>
                            {dict.Receipt_Payment_TXT[profile?.language]}
                        </Typography>
                    </Stack>
                    <Stack direction={"row"} justifyContent={"space-between"} spacing={1} mt={1}>
                        <Button variant="outlined" startIcon={<FileDownload />} sx={{ width: "100%", borderRadius: "5px" }} onClick={() => window.open(element.receipt_link_eng)}><Typography variant='body2'>English</Typography></Button>
                        <Button variant="outlined" startIcon={<FileDownload />} sx={{ width: "100%", borderRadius: "5px" }} onClick={() => window.open(element.receipt_link)}><Typography variant='body2'>ภาษาไทย</Typography></Button>
                    </Stack>
                </>
            }


        </Box>
    }

    const InsideCardCheckboxInvoice = ({ element , summary }) => {
        return (
            <Box sx={{ width: "100%", padding: "18px" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                        checked={isInvoiceChecked(element)}
                        indeterminate={isInvoiceIndeterminate(element)}
                        onChange={() => handleCheckInvoice(element)}
                        disabled={element.disbale}
                    />
                    <Typography variant='body2' fontWeight={"bold"}>{element?.invoice_no}</Typography>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', paddingTop: 10, paddingInline: 16, paddingBottom: 10, gap: 10 }}>
                    {tabSelected === 'waiting' ? element.data.map((item, index) => {
                    let invoicePayable = item.invoice_payable !== undefined ? Boolean(item.invoice_payable) : true // true or undefined สามารถติ๊กได้ false ไม่สามารถติ๊กได
                        return (
                            <Box
                                key={index}
                                sx={{
                                    width: "100%",
                                    padding: "2px 3px",
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                }}
                            >
                                <Stack direction="row" justifyContent="space-between">
                                    <Typography variant="body2" fontWeight={"bold"} sx={{ wordBreak: "break-word" }}>
                                        <Checkbox
                                            checked={isTermChecked(item)}
                                            onChange={() => handleCheckTerms([item])}
                                            disabled={invoicePayable === false ? true : item.disbale}
                                        />
                                        {profile?.language === "th" ? item.term_name : item.term_name_eng || "-"}
                                    </Typography>
                                </Stack>
                                <Box sx={{ paddingInline: 2, paddingBottom: 2 }}>
                                    <Stack direction="row" justifyContent="space-between" mt={1}>
                                        <Typography variant="body2" >
                                            {dict.Pay_Due_TXT[profile?.language]}

                                        </Typography>
                                        <Typography variant="body2" fontWeight={"bold"}>
                                            {/* {tabSelected === "waiting" ? moment(item.invoice_due_date).format("DD/MM/YYYY") : moment(item.payment_date).format("DD/MM/YYYY")} */}
                                            {moment(item.invoice_due_date).format("DD/MM/YYYY")}
                                        </Typography>
                                    </Stack>
                                    <Stack direction="row" justifyContent="space-between" mt={1}>
                                        <Typography variant="body2" sx={{ flexShrink: 0 }} >
                                            {dict.Bill_Amount_TXT[profile?.language]}

                                        </Typography>
                                        <Typography variant="body2" fontWeight={"bold"} sx={{ wordBreak: "break-word" }}>
                                            {tabSelected === "waiting" ? (item.balance?.toLocaleString()) : payOrPaid(item)} {dict.Baht_TXT[profile?.language]}
                                        </Typography>
                                    </Stack>
                                    <Stack direction="row" justifyContent="space-between" mt={1}>
                                        <Typography variant="body2" >
                                            {dict.Bill_Status_TXT[profile?.language]}
                                        </Typography>
                                        <Typography variant="caption" >
                                            {tabSelected === "waiting" ? <Chip label={statusShows(item.invoice_due_date)} /> : <Chip label={receiptStatusShows(item.status_upload)} />}
                                        </Typography>
                                    </Stack>
                                </Box>
                            </Box>
                        )
                    }) : <></>}
                    {
                        (tabSelected === "waiting" && (element.invoice_link && element.invoice_link_eng)) && <>
                            <Stack sx={{ ml: -10, mr: -10, mt: 2 }} />
                            <div style={{ width: "100%", height: 20 }} ></div>
                            <Stack direction={"row"} justifyContent={"space-between"} spacing={1} mt={1} sx={{ padding: "5px 10px", borderRadius: "5px", position: "absolute", bottom: 0, left: 0, right: 0, height: 50, alignItems: 'center' }}>
                                <Button variant="outlined" startIcon={<FileDownload />} sx={{ width: "100%", height: "70%", borderRadius: "5px", backgroundColor: '#FFFFFF' }} onClick={() => window.open(element.invoice_link_eng)}><Typography variant='body2'>English</Typography></Button>
                                <Button variant="outlined" startIcon={<FileDownload />} sx={{ width: "100%", height: "70%", borderRadius: "5px", backgroundColor: '#FFFFFF' }} onClick={() => window.open(element.invoice_link)}><Typography variant='body2'>ภาษาไทย</Typography></Button>
                            </Stack>
                        </>
                    }
                    {
                        tabSelected === "history" && <Stack direction="row" justifyContent="space-between" mt={1}>
                            <Typography variant="body2" >
                                {dict.Pay_Date_TXT[profile?.language]}

                            </Typography>
                            <Typography variant="body2" fontWeight={"bold"}>
                                {/* {tabSelected === "waiting" ? moment(element.invoice_due_date).format("DD/MM/YYYY") : moment(element.payment_date).format("DD/MM/YYYY")} */}
                                {moment(element.payment_date).format("DD/MM/YYYY")}
                            </Typography>
                        </Stack>
                    }
                    {
                        tabSelected === "history" && <Stack direction="row" justifyContent="space-between" mt={1}>
                            <Typography variant="body2" >
                                {dict.Pay_Via_TXT[profile?.language]}

                            </Typography>
                            <Typography variant="body2" fontWeight={"bold"} >
                                {element.receipt_payment_type_text || "-"}
                            </Typography>
                        </Stack>
                    }
                    {
                        (element.term_id === "100" && tabSelected !== "history" && element?.contract_down_period !== "" && element?.contract_down_period !== undefined) && <Stack direction="column" mt={1}>
                            <Typography variant="body2" fontWeight={"bold"} color={"red"} >
                                {dict.Remark_TXT[profile?.language]} :
                            </Typography>
                            <Typography variant="body2" >
                                {dict.Split_Payment_TXT[profile?.language]}
                            </Typography>
                            <Typography variant="body2">
                                {dict.Split_Payment_2_TXT[profile?.language] + " " + element.contract_down_period + " " + dict.Split_Payment_3_TXT[profile?.language]}
                            </Typography>
                            <Typography variant="body2">
                                {dict.Split_Payment_4_TXT[profile?.language] + " " + (Number(element.contract_down_per_payment)).toLocaleString() + " " + dict.Split_Payment_5_TXT[profile?.language]}
                            </Typography>
                        </Stack>
                    }
                    {tabSelected === "history" && <Stack direction="row" justifyContent="space-between" mt={1}>
                        <Typography variant="body2" >
                            {dict.Bill_Status_TXT[profile?.language]}
                        </Typography>
                        <Typography variant="caption" >
                            {tabSelected === "waiting" ? <Chip label={statusShows(element.invoice_due_date)} /> : <Chip label={receiptStatusShows(element.status_upload)} />}
                        </Typography>
                    </Stack>
                    }

                    {
                        (tabSelected === "history" && (element.status_upload === "ชำระเงินสำเร็จ" || element.status_upload === "Payment Confirmed")) && <>
                            <Divider sx={{ ml: -10, mr: -10, mt: 2 }} />
                            <Stack direction={"row"} justifyContent={"center"} mt={1}>
                                <Typography variant='body1' fontWeight={"bold"} color={theme.palette.primary.main}>
                                    {dict.Receipt_Payment_TXT[profile?.language]}
                                </Typography>
                            </Stack>
                            <Stack direction={"row"} justifyContent={"space-between"} spacing={1} mt={1}>
                                <Button variant="outlined" startIcon={<FileDownload />} sx={{ width: "100%", borderRadius: "5px" }} onClick={() => window.open(element.receipt_link_eng)}><Typography variant='body2'>English</Typography></Button>
                                <Button variant="outlined" startIcon={<FileDownload />} sx={{ width: "100%", borderRadius: "5px" }} onClick={() => window.open(element.receipt_link)}><Typography variant='body2'>ภาษาไทย</Typography></Button>
                            </Stack>
                        </>
                    }
                </div>
            </Box>
        )
    }

    const checkCompanyId = () => {
        let productType = checkProductType()
        if (productType === "rental") {
            return localStorage.getItem("cid_rental")
        }
        if (productType === "pmlite") {
            return localStorage.getItem("cid_pm")
        }
        return localStorage.getItem("cid")
    }
    useEffect(() => {

        const loadAccountToCheckMerchantId = async () => {
            // if (isKbank !== "true") return
            try {
                let account = await axios.post(
                    `${process.env.REACT_APP_LINEOA_V2_HOST_API}/kbankpay/account_qr`,
                    {
                        project_id: houseInfo.project_id,
                        company_id: checkCompanyId()
                    }
                );

                if (!account?.data?.data?.qr_merchant_id) {
                    setNoMerchantId(true)
                    setCallCenter(account?.data?.data?.call_center_phone?.Telephone)
                }
            } catch (error) {
                setCallCenter(error?.response?.data?.data?.call_center_phone?.Telephone)
                setNoMerchantId(true)
            }
        }

        const loadBillPaymentHistory = async () => {
            setLoadingBackDrop(true)
            const basePayload = {
                "line_id": profile?.line_id,
                "project_id": houseInfo.project_id || houseInfoParse.project_id,
                "unit_number": houseInfo.unit_number || houseInfoParse.unit_number,
                "is_rem": houseInfo.is_rem || houseInfoParse.is_rem,
                "is_pm": houseInfo.is_pm || houseInfoParse.is_pm,
                "is_rental": houseInfo.is_rental || houseInfoParse.is_rental
            }

            // Only add contract_id if product type is rental
            if (checkProductType() === "rental") {
                basePayload.contract_id = houseInfo?.contract_id?.contractSelected?.contract_id ||
                    houseInfoParse?.contractSelected?.contract_id
            }

            let res = await api.getBillPaymentHistory(basePayload)

            const projectPayload = {
                "project_id": houseInfo?.project_id,
                "line_id": profile?.line_id,
                "product_type": houseInfo?.product_type,
            }

            if (checkProductType() === "rental") {
                projectPayload.contract_id = houseInfo?.contract_id?.contractSelected?.contract_id ||
                    houseInfoParse?.contractSelected?.contract_id
            }

            let resProject = await apiMain.getLatestProject(projectPayload)
            setProjectDetail(resProject?.data?.data)
            setLoadingBackDrop(false)
            setIsDataReady(true)
            if (res == null) return

            let objData = res.data
            let tempPM = []
            let tempREM = []
            objData?.map(element => {
                if (element.product_type === "remlite") {
                    return tempREM.push(element)
                }
                return tempPM.push(element)
            })
            if (objData.length === 0) {
                setHasAnyData(false)
            }
            else {
                setHasAnyData(true)
            }
            setBillPaymentPM(tempPM) // use for rental and pmlite
            setBillPaymentREM(tempREM)
        }

        const loadBillPayment = async () => {

            setLoadingBackDrop(true)
            const basePayload = {
                "line_id": lineId,
                "project_id": houseInfo?.project_id || houseInfoParse.project_id,
                "unit_number": houseInfo?.unit_number || houseInfoParse.unit_number,
                "is_rem": houseInfo?.is_rem || houseInfoParse.is_rem,
                "is_pm": houseInfo?.is_pm || houseInfoParse.is_pm,
                "is_rental": houseInfo?.is_rental || houseInfoParse.is_rental,
                "payment_type": checkPaymentType()
            }

            // Only add contract_id if product type is rental
            if (checkProductType() === "rental") {
                basePayload.contract_id = houseInfo?.contract_id?.contractSelected?.contract_id ||
                    houseInfoParse?.contractSelected?.contract_id
            }

            let res = await api.getBillPayment(basePayload)

            const projectPayload = {
                "project_id": houseInfo?.project_id,
                "line_id": profile?.line_id,
                "product_type": houseInfo?.product_type,
            }

            if (checkProductType() === "rental") {
                projectPayload.contract_id = houseInfo?.contract_id?.contractSelected?.contract_id ||
                    houseInfoParse?.contractSelected?.contract_id
            }

            let resProject = await apiMain.getLatestProject(projectPayload)
            setProjectDetail(resProject?.data?.data)
            setLoadingBackDrop(false)
            setIsDataReady(true)
            if (res == null) return


            let objData = res.data
            let tempPM = []
            let tempREM = []
            let totalBalance = 0
            objData?.map(element => {
                if (element.product_type === "remlite") {
                    totalBalance += element.balance
                    return tempREM.push(element)
                }
                return tempPM.push(element)
            })
            if (tempPM.length === 0 && tempREM.length === 0) {
                setHasAnyData(false)
            }
            else {
                setHasAnyData(true)
            }
            setBillPaymentPM(tempPM)
            setBillPaymentREM(tempREM)
            setTotalBalance(totalBalance)
        }

        const loadBillPaymentV2 = async () => {
            // 192 autoleasing
            setLoadingBackDrop(true)
            const basePayload = {
                "line_id": profile?.line_id,
                "project_id": houseInfo.project_id || houseInfoParse.project_id,
                "unit_number": houseInfo.unit_number || houseInfoParse.unit_number,
                "is_rem": houseInfo.is_rem || houseInfoParse.is_rem,
                "is_pm": houseInfo.is_pm || houseInfoParse.is_pm,
                "is_rental": houseInfo.is_rental || houseInfoParse.is_rental
            }

            // Only add contract_id if product type is rental
            if (checkProductType() === "rental") {
                basePayload.contract_id = houseInfo?.contract_id?.contractSelected?.contract_id ||
                    houseInfoParse?.contractSelected?.contract_id
            }

            let res = await api.getBillPaymentHistoryV2(basePayload)
            if (res.status !== 200){
                return
            }
            const termList = []
            const groupInvoice = res?.data.data.reduce((prev, curr) => {
                const foundTermIndex = termList.findIndex((item) => item === curr.term_id)
                let isTermExist = false
                if (foundTermIndex === -1) {
                    termList.push(curr.term_id)
                }
                else{
                    isTermExist = true
                }
                const invoice_no = curr.invoice_no
                const foundInvoiceIndex = prev.findIndex((item) => item.invoice_no === invoice_no)
                if (foundInvoiceIndex !== -1) {
                    const newTerms = [...prev[foundInvoiceIndex].data, {
                        ...curr,
                        disbale: isTermExist
                    }]
                    const sortedTerms = newTerms.sort((a, b) => a.term_id.localeCompare(b.term_id))
                    prev[foundInvoiceIndex].data = [...sortedTerms]
                }
                else{
                    prev.push({ 
                        invoice_no: invoice_no,
                        invoice_date: curr.invoice_date,
                        invoice_link: curr.invoice_link,
                        invoice_link_eng: curr.invoice_link_eng,
                        is_term_step_exist: isTermExist,
                        disbale: isTermExist,
                        data: [{
                            ...curr,
                            disbale: isTermExist
                        }]
                    })
                }
                return prev
            }, [])
            setSummaryBillPaymentRental(res?.data?.summary)
            setBillPaymentRental(groupInvoice)
            setLoadingBackDrop(false)
            setIsDataReady(true)
            if (groupInvoice.length === 0) {
                setHasAnyData(false)
            }
            else {
                setHasAnyData(true)
            }
        }

        const handleSelectedTab = async () => {

            if (tabSelected === "waiting") {
                if (version === "2") {
                    return loadBillPaymentV2()
                }
                return loadBillPayment()
            }

            if (tabSelected === "history") {
                return loadBillPaymentHistory()
            }
            return
        }

        if (lineId !== null) {
            loadAccountToCheckMerchantId()
            setBillPaymentREM([])
            setBillPaymentPM([])
            handleSelectedTab()
        }

    }, [tabSelected, lineId, houseInfo, houseInfoParse, profile?.line_id])

    useEffect(() => {
        if (methodType !== null) {
            const terms = checkTerms.map((item) => {
                return {
                    term_id: item.term_id,
                    term_name: item.term_name,
                    term_name_en: item.term_name_eng,
                    invoice_no: item.invoice_no,
                    invoice_balance: item.balance,
                    amount: item.amount,
                    ref_id: item.reference_id
                }
            })
            const billpaymentParentPath = version === "2" ? "billpaymentV2" : "billpayment"
            switch (methodType) {
                case 'qr-scb':
                case 'qr-kbank':
                case 'credit-kbank':
                case 'qr': navigate(`/${billpaymentParentPath}/amountPayment` + location.search, {
                    state: { ...detail, totalBalance, methodType, terms }
                })
                    break;
                case 'qr-2c2p': navigate(`/${billpaymentParentPath}/amountPayment` + location.search, {
                    state: { ...detail, totalBalance, methodType, terms }
                })
                    break;
                case '2c2p-normal': navigate(`/${billpaymentParentPath}/amountPayment` + location.search, {
                    state: { ...detail, totalBalance, methodType, terms }
                })
                    break;
                case 'credit': navigate(`/${billpaymentParentPath}/creditCardSelecting` + location.search, {
                    state: { ...detail, totalBalance, methodType }
                })
                    break;
                case 'mobile-banking': navigate(`/${billpaymentParentPath}/bankSelecting` + location.search, {
                    state: { ...detail, totalBalance, methodType, terms }
                })

                    break;
                default:
            }
        }
    }, [methodType, location.search, detail, navigate])

    useEffect(() => {

        if (location.state?.forceReloadPage === true) {
            window.history.replaceState({}, document.title)
            window.location.reload()
        }

    }, [location])

    useEffect(() => {

        let profileLineOA = JSON.parse(localStorage.getItem("profile_lineOA"))
        if (profileLineOA !== null || profileLineOA !== undefined) {
            let lineIdCache = profileLineOA?.profile?.userId
            setLineId(lineIdCache)
        }

        setTabSelected(tabSelected)
        setNoMerchantId(false)

    }, [tabSelected])

    useEffect(() => {

        if (context.state?.profile !== null) {
            setProfile(context.state?.profile?.customer[0])
        }

        if (context.state?.houseInfo !== null) {
            setHouseInfo(context.state?.houseInfo)
        }

    }, [context])

    const handleUploadSlip = async () => {
        if (!selectedFile) return;

        setLoadingBackDrop(true);
        setUploadSlipError(false)

        try {
            // อัปโหลดรูปภาพ
            const uploadResult = await uploadSlipImage(selectedFile);
            console.log('uploadResult', uploadResult)
            if (uploadResult?.success === true) {
                // บันทึกข้อมูลสลิป
                const saveResult = await saveSlipData(uploadResult?.fileId?.id);

                if (saveResult.success) {
                    console.log("Slip uploaded successfully");
                    // ปิด dialog และรีเซ็ตค่า
                    setSelectedFile(null);
                    setShowSuccessMessage(true);
                }
                else{
                    setUploadSlipError(true)
                }
            }
        } catch (error) {
            console.error("Error uploading slip:", error);
            setUploadSlipError(true)
        } finally {
            setLoadingBackDrop(false);
        }
    };

    const uploadSlipImage = async (file) => {
        try {
            let res = await api.uploadImg(file, {
                subject: "slip",
                product: "lineoa",
                company_id: houseInfo?.company_id
            });

            if (res.status === 200) {
                return { success: true, fileId: res.data };
            }
            return { success: false, error: "Upload failed" };
        } catch (error) {
            return { success: false, error };
        }
    };
    const saveSlipData = async (fileId) => {
        let contract_id
        if (checkProductType() === "rental") {
                contract_id = houseInfo?.contract_id?.contractSelected?.contract_id ||
                    houseInfoParse?.contractSelected?.contract_id
        }
        try {
            // console.log(checkTerms, 'checkTerms')
            const groupInvoice = checkTerms.reduce((prev, curr) => {
                const foundInvoiceIndex = prev.findIndex((item) => item.invoice_id === curr.invoice_no)
                if (foundInvoiceIndex === -1) {
                    return [...prev, { invoice_id: curr.invoice_no }]
                }
                return prev
            }, [])
            let res = await api.uploadSlip({
                company_id: houseInfo?.company_id,
                line_id: profile?.line_id,
                language: profile?.language,
                product_type: houseInfo?.product_type,
                project_id: houseInfo?.project_id,
                items: groupInvoice, // หรือข้อมูลที่ต้องการส่ง
                contract_id: contract_id,
                file_id: fileId
            });

            if (res.status === 200) {
                return { success: true };
            }
            return { success: false, error: "Save failed" };
        } catch (error) {
            return { success: false, error };
        }
    };


    // const hasAnyData = (billPaymentPM?.length > 0) || (billPaymentREM?.length > 0) || (billPaymentRental?.length > 0);
    return (
        <>
            <AppBar sx={{
                position: 'fixed',
                boxShadow: 'none',
                height: 60,
            }}>
                <Toolbar>
                    <Grid container item xs={1}>
                        <ArrowBackIos onClick={() => navigate(`/myhome${location.search}`)} />
                    </Grid>
                    <Grid container item xs={10} direction="row"
                        justifyContent="center"
                    >
                        <Typography>
                            {location.state?.title}
                        </Typography>

                    </Grid>

                </Toolbar>


            </AppBar>

            <Box sx={{ minWidth: "100%", position: "fixed", zIndex: 10, mt: 7 }} >
                <Tabs
                    value={tabSelected}
                    onChange={(e, val) => setTabSelected(val)}
                    textColor="secondary"
                    indicatorColor="secondary"
                    centered
                    variant="fullWidth"
                    sx={{ backgroundColor: "white" }}

                >
                    <Tab value="waiting" label={dict.Wait_Pay_TXT[profile?.language]} />
                    <Tab value="history" label={dict.History_TXT[profile?.language]} />

                </Tabs>
            </Box>

            <Container maxWidth="xl" sx={{ mb: 5 }} >

                <BackDropLoading
                    loading={loadingBackDrop}
                />


                <Stack direction={"row"} alignItems="center" justifyContent={"flex-start"}>
                    <ChipRoomInfo
                        houseInfo={houseInfo}
                        houseInfoParse={houseInfoParse}
                        icon={<HolidayVillage />}
                        lang={profile?.language}
                        sx={{
                            mt: 17
                        }}
                    />
                </Stack>
                <>
                    {hasAnyData ? (
                        <>
                        {(tabSelected === 'waiting' && version === '2') && (Object.keys(summaryBillPaymentRental).length > 0) && <Box sx={{ justifyContent: 'space-evenly', alignItems: 'center', paddingTop: 3, display: 'flex', gap: 2, position: 'relative' }}>
                    {/* ยอดที่ต้องชำระ */}
                    {/* {(tabSelected === 'waiting' && version === '2' && Object.keys(summaryBillPaymentRental).length > 0) && <Box sx={{ justifyContent: 'space-evenly', alignItems: 'center', paddingTop: 3, display: 'flex', gap: 2, position: 'relative' }}> */}

                    <Stack direction="column" spacing={1} style={{ flex: 1 }}>
                        <Typography
                            variant="body2"
                            fontWeight="medium"
                            sx={{ wordBreak: "break-word" }}
                        >
                            {dict.Total_overdude_balance_TXT[profile?.language]}
                        </Typography>
                        <Stack direction="row" alignItems='center' gap={1}>
                            <Box
                                sx={{
                                    '& .MuiInputBase-input': {
                                        textAlign: 'center',
                                        fontWeight: 'bold'
                                    },
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    width: '100%'
                                }}
                            >
                                {!(isNaN(summaryBillPaymentRental?.main_overdue_amount) && isNaN(summaryBillPaymentRental?.extend_overdue_amount)) && `
                                        ${(summaryBillPaymentRental?.main_overdue_amount + summaryBillPaymentRental?.extend_overdue_amount).toLocaleString('th-TH', { minimumFractionDigits: 2 }) || 0}
                                    `
                                }
                            </Box>
                            <Typography variant="body2">บาท</Typography>
                        </Stack>
                    </Stack>

                    {/* ยอดคงค้าง */}
                    <Stack direction="column" spacing={1} style={{ flex: 1 }}>
                        <Typography
                            variant="body2"
                            fontWeight="medium"
                            sx={{ wordBreak: "break-word" }}
                        >
                            {dict.Total_all_balance_TXT[profile?.language]}
                        </Typography>
                        <Stack direction="row" alignItems='center' gap={1}>
                            <Box
                                sx={{
                                    '& .MuiInputBase-input': {
                                        textAlign: 'center',
                                        fontWeight: 'bold'
                                    },
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    width: '100%'
                                }}
                            >
                                {!(isNaN(summaryBillPaymentRental?.main_remain_amount) && isNaN(summaryBillPaymentRental?.extend_remain_amount) )&& `
                                        ${(summaryBillPaymentRental?.main_remain_amount + summaryBillPaymentRental?.extend_remain_amount).toLocaleString('th-TH', { minimumFractionDigits: 2 }) || 0}
                                    `
                                }
                            </Box>
                            <Typography variant="body2">บาท</Typography>
                        </Stack>
                    </Stack>
                    <div style={{ position: "absolute", right: 0, top: 25 }}>
                        <OpenInNew
                            color="primary"
                            onClick={() => navigate(`/billpaymentV2/summary${location.search}`, { state: summaryBillPaymentRental })}
                        >
                            summaryDetail
                        </OpenInNew>
                    </div>
                </Box>}
                            {/* Bill Payment PM Section */}
                            {billPaymentPM?.length > 0 && (
                                <>
                                    <Box sx={{ marginTop: 3 }}>
                                        <Divider textAlign="left">
                                            <Typography variant='subtitle1'>
                                                {dict.General_Expense_TXT[profile?.language]}
                                            </Typography>
                                        </Divider>
                                    </Box>

                                    <Stack mt={2} spacing={2}>
                                        {billPaymentPM?.map((element, index) => {
                                            return (
                                                <CustomWatermarkCard
                                                    watermarkText={checkShowWaterMark(element) === true && tabSelected === "waiting" ? dict.Payment_Not_Available_TXT[profile?.language] : ""}
                                                    key={index}
                                                    variant="outlined"
                                                    sx={{
                                                        borderRadius: "10px",
                                                        boxShadow: "0px 0px 7px 0px #00000040",
                                                        display: "flex",
                                                        backgroundColor: backgroundDisabled(element, index, billPaymentPM)
                                                    }}
                                                    onClick={() => {
                                                        if (checkDisabled(element, index, billPaymentPM) === true && tabSelected === "waiting") {
                                                            return;
                                                        }
                                                        if (tabSelected === "waiting") {
                                                            setDetail({ ...element, language: profile.language });
                                                            setIsVisibleMenuMethod(true);
                                                            return;
                                                        }
                                                    }}
                                                >
                                                    <InsideCard element={element} />
                                                </CustomWatermarkCard>
                                            );
                                        })}
                                    </Stack>
                                </>
                            )}

                            {/* Bill Payment REM Section */}
                            {billPaymentREM?.length > 0 && (
                                <>
                                    <Box sx={{ marginTop: 3 }}>
                                        <Divider ref={myRef} textAlign="left">
                                            <Typography variant='subtitle1'>
                                                {dict.Pending_Pay_TXT[profile?.language]}
                                            </Typography>
                                        </Divider>
                                    </Box>
                                    <Stack mt={2} spacing={2}>
                                        {billPaymentREM?.map((element, index) => {
                                            return (
                                                <CustomWatermarkCard
                                                    watermarkText={checkShowWaterMark(element) === true && tabSelected === "waiting" ? dict.Payment_Not_Available_TXT[profile?.language] : ""}
                                                    key={index}
                                                    variant="outlined"
                                                    sx={{
                                                        borderRadius: "10px",
                                                        boxShadow: "0px 0px 7px 0px #00000040",
                                                        display: "flex",
                                                        backgroundColor: backgroundDisabled(element, index, billPaymentREM)
                                                    }}
                                                    onClick={() => {
                                                        if (checkDisabled(element, index, billPaymentREM) === true && tabSelected === "waiting") {
                                                            return;
                                                        }
                                                        if (tabSelected === "waiting") {
                                                            setDetail(element);
                                                            setIsVisibleMenuMethod(true);
                                                        }
                                                    }}
                                                >
                                                    <InsideCard element={element} />
                                                </CustomWatermarkCard>
                                            );
                                        })}
                                    </Stack>
                                </>
                            )}

                            {/* Bill Payment Rental Section */}
                            {billPaymentRental?.length > 0 && (
                                <>
                                    {tabSelected === "waiting" && (
                                        <Box sx={{ marginTop: 3 }}>
                                            <Divider ref={myRef} textAlign="left">
                                                <Typography variant='subtitle1'>
                                                    {dict.General_Expense_TXT[profile?.language]}
                                                </Typography>
                                            </Divider>
                                        </Box>
                                    )}
                                    <Stack mt={2} spacing={2}>
                                        {tabSelected === "waiting" && billPaymentRental.map((element, index) => {
                                            return (
                                                <CustomWatermarkCard
                                                    watermarkText={checkShowWaterMark(element) === true && tabSelected === "waiting" ? dict.Payment_Not_Available_TXT[profile?.language] : ""}
                                                    key={index}
                                                    variant="outlined"
                                                    sx={{
                                                        borderRadius: "10px",
                                                        boxShadow: "0px 0px 7px 0px #00000040",
                                                        display: "flex",
                                                        backgroundColor: backgroundDisabled(element, index, billPaymentRental)
                                                    }}
                                                >
                                                    <InsideCardCheckboxInvoice element={element} summary={summaryBillPaymentRental} />
                                                </CustomWatermarkCard>
                                            );
                                        })}
                                    </Stack>
                                </>
                            )}
                        </>
                    ) : (
                        isDataReady === true &&
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '200px',
                            flexDirection: 'column'
                        }}
                        
                        >
                            <Typography variant="h6" color="textSecondary">
                                {dict.No_Data_TXT[profile?.language] || "No Data Available"}
                            </Typography>
                        </Box>
                    )}
                </>

            </Container >

            {checkTerms.length > 0 && <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, padding: '16px', backgroundColor: 'white', boxShadow: '0px -2px 4px rgba(0,0,0,0.1)', zIndex: 1000 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <Typography variant="subtitle1">{dict.Total_Amount_TXT[profile?.language]}</Typography>
                        <Typography variant="h6">฿ {totalBalance.toLocaleString('th-TH', { maximumFractionDigits: 2 })}</Typography>
                    </div>
                    {/* {selectedFile && <Typography variant="body2" sx={{ mt: 2 }}>
                        {selectedFile.name}
                    </Typography>} */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'center' }}>
                        {showUploadSlip && <Button
                            variant="outlined"
                            sx={{
                                width: "180px",
                                height: "50px",
                                fontSize: 16,
                                fontWeight: 500,
                                borderRadius: "8px",
                                borderWidth: "2px",
                                borderColor: theme.palette.primary.main,
                                color: theme.palette.primary.main,
                                '&:hover': {
                                    borderWidth: "2px",
                                    backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                }
                            }}
                            startIcon={<Upload />}
                            onClick={() => {
                                // Trigger file input click
                                setShowImageDialog(true);
                            }}
                        >
                            {dict.Upload_Slip_TXT[profile?.language]}
                        </Button>}
                        <input
                            id="cameraFileInput"
                            type="file"
                            accept="image/*"
                            // capture="environment" ปิดไว้เพราะ ios จะเลือกอัลบั้มไม่ได้
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                        />
                        <Button
                            variant="contained"
                            sx={{
                                width: showUploadSlip ? "180px" : "220px",
                                height: "50px",
                                fontSize: 18,
                                fontWeight: 600,
                                borderRadius: "8px",
                                backgroundColor: theme.palette.primary.main,
                                '&:hover': {
                                    backgroundColor: theme.palette.primary.dark
                                }
                            }}
                            onClick={() => {
                                const invoiceDetail = checkTerms[0]
                                const payload = {
                                    ...invoiceDetail,
                                    line_id: profile?.line_id,
                                    balance: totalBalance,
                                    totalBalance: totalBalance,
                                    invoices: checkTerms,
                                    product_type: houseInfo?.product_type,
                                }

                                // sort terms by invoice_id, then sort by term_id
                                if (payload.invoices?.length > 0) {
                                    payload.invoices.sort((a, b) => {
                                        const invoiceCompare = a.invoice_no.localeCompare(b.invoice_no);
                                        if (invoiceCompare !== 0) {
                                            return invoiceCompare;
                                        }
                                        return a.term_id.localeCompare(b.term_id);
                                    })
                                }

                                setDetail(payload)
                                setIsVisibleMenuMethod(true)
                            }}
                        >
                            {dict.Pay_TXT[profile?.language]}
                        </Button>
                    </div>
                </div>
            </div>}

            <SwipeableDrawer
                anchor={'bottom'}
                disableSwipeToOpen
                open={isVisibleMenuMethod}
                onClose={() => {
                    setIsVisibleMenuMethod(false)
                    // เอาออกก่อนไม่แน่ใจว่ามีผลอะไรไหม setDetail(null)
                }}
                onOpen={() => setIsVisibleMenuMethod(true)}
            >
                <Box sx={{ minHeight: isScb === "true" ? "19vh" : "35vh" }}>
                    <Paper variant="outlined" sx={{ height: "50px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Typography>{dict.Choose_Method_TXT[profile?.language]}</Typography>
                    </Paper>

                    {
                        noMerchantId && <Box sx={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            background: "rgb(60, 60, 60, 0.9)",
                            bottom: 0,
                            zIndex: "50",
                            alignContent: "center",
                            textAlign: "center"
                        }}>
                            <Typography variant='h6' color={"white"}>{dict.Choose_Method_Block_Title_TXT[profile?.language]}</Typography>
                            <br />
                            <Typography variant='h6' color={"white"}>{dict.Choose_Method_Block_Title_2_TXT[profile?.language]}</Typography>
                            <br />
                            <Divider sx={{ color: "white" }} color={"white"} variant='middle' />
                            <br />
                            <Typography color={"white"}>{dict.Choose_Method_Block_Title_3_TXT[profile?.language]}</Typography>
                            <Typography color={"white"}>Call Center {callCenter}</Typography>
                        </Box>
                    }

                    <List>
                        <ListItem
                            sx={{ height: "80px", display: "flex", alignItems: "center" }}
                            onClick={() => {
                                if (isKbank === "true") {
                                    return setMethodType("qr-kbank")
                                }
                                if (isScb === "true") {
                                    return setMethodType("qr-scb")
                                }
                                if (is2c2p === "true") {
                                    return setMethodType("qr-2c2p")
                                }
                                return setMethodType("qr")
                            }}
                        >
                            <Stack spacing={2} direction="row" alignItems="center">
                                <CardMedia
                                    component="img"
                                    sx={{ width: 55 }}
                                    src={logoQrcode}
                                />
                                <Typography>{dict.Pay_via_Qr_TXT[profile?.language]}</Typography>
                            </Stack>
                        </ListItem>
                        {isScb !== "true" ? <Divider light /> : null}
                        {
                            checkDisabledCreditMethod(detail?.term_id) === false && isScb !== "true" && is2c2p !== "true" && <> <ListItem
                                sx={{ height: "80px", display: "flex", alignItems: "center", }}
                                onClick={() => {
                                    if (isKbank === "true") {
                                        return setMethodType("credit-kbank")
                                    }
                                    return setMethodType("credit")
                                }} >
                                <Stack spacing={2} direction="row" alignItems="center">
                                    <CardMedia
                                        component="img"
                                        sx={{ width: 55 }}
                                        src={logoDebitCard}
                                    />
                                    <Typography>{dict.Pay_via_Card_TXT[profile?.language]}</Typography>
                                </Stack>
                            </ListItem>
                                <Divider light />
                            </>
                        }
                        {
                            (isKbank !== "true" && isScb !== "true" && is2c2p !== "true") && <ListItem
                                sx={{ height: "80px", display: "flex", alignItems: "center" }}
                                onClick={() => {
                                    setMethodType("mobile-banking")
                                }} >
                                <Stack spacing={2} direction="row" alignItems="center">
                                    <CardMedia
                                        component="img"
                                        sx={{ width: 55 }}
                                        src={logoMobileBank}
                                    />
                                    <Typography >{dict.Pay_via_MobileBank_TXT[profile?.language]}</Typography>
                                </Stack>
                            </ListItem>
                        }
                        {
                            (isKbank !== "true" && isScb !== "true" && is2c2p === "true" && disable2c2pMethod !== "true") && <ListItem
                                sx={{ height: "80px", display: "flex", alignItems: "center" }}
                                onClick={() => 
                                    setMethodType("2c2p-normal")
                                }
                                >
                                <Stack spacing={2} direction="row" alignItems="center">
                                    <CardMedia
                                        component="img"
                                        sx={{ width: 55 }}
                                        src={logo2c2p}
                                    />
                                    <Typography >{dict.Pay_via_2c2p_TXT[profile?.language]}</Typography>
                                </Stack>
                            </ListItem>
                        }
                        {isScb !== "true" ? <Divider light /> : null}
                        
                    </List>
                </Box>

            </SwipeableDrawer>

            {/* Image Preview Dialog */}
            <Dialog
                open={showImageDialog}
                onClose={showSuccessMessage ? null : handleCloseImageDialog}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {showSuccessMessage ? "อัปโหลดสลิปสำเร็จ" : dict.Upload_Slip_TXT[profile?.language]}
                    {!showSuccessMessage && (
                        <IconButton onClick={handleCloseImageDialog}>
                            <Close />
                        </IconButton>
                    )}
                </DialogTitle>
                <DialogContent>
                    {showSuccessMessage ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', py: 4 }}>
                            <CardMedia
                                component="img"
                                sx={{ width: "30%", mb: 2 }}
                                src={logoCheck}
                            />
                            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                                อัปโหลดสลิปสำเร็จ
                            </Typography>
                            <Typography variant="body1">
                                Upload Successful
                            </Typography>
                        </Box>
                    ) : (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                            <img
                                src={selectedFile ? URL.createObjectURL(selectedFile) : logoNoImage}
                                alt="Slip preview"
                                style={{ maxWidth: '100%', maxHeight: '400px' }}
                            />
                            {selectedFile && (
                                <Typography variant="body2" sx={{ mt: 2 }}>
                                    {selectedFile.name || "slip_image.png"}
                                </Typography>
                            )}
                        </Box>
                    )}
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' , gap : 2 }}>
                    {showSuccessMessage ? (
                        <Button
                            variant='contained'
                            onClick={() => {
                                setShowImageDialog(false);
                                setFileSizeError(false);
                                setTimeout(() => {
                                    setShowSuccessMessage(false);
                                    setSelectedFile(null);
                                }, 200)
                            }}
                            sx={{
                                backgroundColor: theme.palette.primary.main,
                                '&:hover': {
                                    backgroundColor: theme.palette.primary.dark
                                }
                            }}
                        >
                            ตกลง
                        </Button>
                    ) : (
                        <Button 
                            variant='outlined' 
                            onClick={() => fileInputRef.current?.click()} 
                            style={{ 
                                fontSize: 16, 
                                fontWeight: 500,
                                borderRadius: "8px",
                                borderWidth: "2px",
                                borderColor: theme.palette.primary.main,
                                color: theme.palette.primary.main,
                            }}
                            
                        >
                            {selectedFile ? "เปลี่ยนรูป" : "อัปโหลดรูป"}
                        </Button>
                    )}
                    {selectedFile &&
                        <Button 
                            variant='contained'
                            style={{
                                borderRadius: "8px",
                                borderWidth: "2px",
                                width: 120,
                            }}
                            onClick={handleUploadSlip}
                        >
                            ยืนยัน
                        </Button>
                    }
                </DialogActions>
                {uploadSlipError && (
                    <Box sx={{ mt: 1 }}>
                        <Alert severity="error">{dict.Upload_Slip_Error_TXT[profile?.language]}</Alert>
                    </Box>
                )}
                {fileSizeError && (
                    <Box sx={{ mt: 1 }}>
                        <Alert severity="error">ขนาดไฟล์ต้องไม่เกิน 1MB (File size must not exceed 1MB)</Alert>
                    </Box>
                )}
            </Dialog>
        </>


    )
}
